import React from 'react'
import { useForm } from 'react-hook-form';
import { PhoneIcon, RssIcon, EnvelopeIcon } from '@heroicons/react/24/solid'


export default function ContactMe() {

    const {
        register,
        handleSubmit,
        formState: { errors },
      } = useForm();

  return (
    <div className='h-screen flex relative flex-col text-center lg:text-left lg:flex-row max-w-7xl px-10 justify-evenly mx-auto items-center'>
        <h3 className='absolute top-24 uppercase tracking-[20px] text-gray-500 text-1xl'>
           Contact
        </h3>

        <div className='flex flex-col md:flex-row space-y-8 mt-5 '>
            <div className='space-y-10'>
               <div className='hidden lg:flex gap-5 justify-center'>
                 <div className='flex items-center space-x-3 justify-center'>
                    <PhoneIcon className='text-[#F7AB0A] h-5 w-5 animate-pulse' />
                    <div className='text-0.5xl lg:text-1.5xl'>+263712579746</div>
                 </div>

                 <div className='flex items-center space-x-3 justify-center'>
                    <EnvelopeIcon className='text-[#F7AB0A] h-5 w-5 animate-pulse' />
                    <div className='text-0.5xl lg:text-1.5xl'>jabulanisikeyi@gmail.com</div>
                 </div>

                 <div className='flex items-center space-x-3 justify-center'>
                    <RssIcon className='text-[#F7AB0A] h-5 w-5 animate-pulse' />
                    <div className='text-0.5xl lg:text-1.5xl'>Bulawayo, Zimbabwe</div>
                 </div>
               </div>
                 <form 
                 onSubmit={handleSubmit((data) => {
                    window.location.href =`mailto: jabulanisikeyi@gmail?subject=${data.subject}&body=Hie, my name is ${data.name}. ${data.message}`
                 })}
                 className='flex flex-col space-y-4 w-fit mx-auto'>
                    <div className='flex lg:space-x-2 space-y-4 lg:space-y-0 flex-col lg:flex-row'>
                        <input {...register('name')} placeholder="Name" type="text" className='contactInput'/>
                        <input {...register('email')} placeholder="Email" type="email" className='contactInput'/>
                    </div>

                    <input {...register('subject')} placeholder="Subject" type="text" className='contactInput'/>

                    <textarea {...register('message')} placeholder="Message" className='contactInput'/>
                    <button className='bg-[#F7AB0A]/40 py-5 px-10 rounded-md text-black font-bold'>Submit</button>
                 </form>
            </div>
        </div>
    </div>
  )
}